import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const getAll = async ({
  pageSize,
  page,
  name,
  groupId,
  role,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Members/all`,
      {
        params: {
          pageSize,
          page,
          name,
          groupId,
          role,
        },
        headers: {
          'ngrok-skip-browser-warning': true
        }
      }
    );

    responseFormat.count = data.count;
    responseFormat.data = data.members;
    responseFormat.error = "";
    
    return responseFormat;
  } catch ({ response }) {
    responseFormat.data = data;
    responseFormat.error = "async";
    return responseFormat;
  }
};


export const getMembersByCommitteeId = async (committeeId) => {
  const languageId = localStorage.getItem("i18nextLng");
  const { data } = await axios.get(
    `${API_BACKEND_HOST}${languageId}/v1/Members/committee/${committeeId}`
  );
  return data;
};